/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
  useNavigateAction,
} from "./utils";
import { Button, Flex, Image, Text } from "@aws-amplify/ui-react";
export default function MobileTerms(props) {
  const {
    logosrc,
    loginurl,
    termsAnchor,
    privacyAnchor,
    homeurl,
    termsurl,
    widthProp,
    supporturl,
    overrides: overridesProp,
    ...rest
  } = props;
  const variants = [
    {
      overrides: {
        "long+logo+overlapped+(1) 142831161": {},
        "Frame 517": {},
        Button: {},
        "Frame 321": {},
        Header: {},
        Heading: {},
        Message42831167: {},
        HeroMessage: {},
        Terms42831171: {},
        Privacy: {},
        Message42831170: {},
        Left: {},
        What: {},
        Guidelines42831177: {},
        "Frame 43242831176": {},
        "Our Promises": {},
        "Frame 42942831181": {},
        "We will always do our best to make our service as safe and secure as possible while also making it work for you We will always minimise the amount of data about you we hold to reduce the risk to you We will always listen to your feedback and continually improve our service We will always refund your subscription if the service has not delivered enough value* If you tell us your gender we will always make sure you are not the only one of your gender at an event We will always do our best to match you with events that most closely match your preferences *if you are not matched with at least 4 runs per month within 2km of where you live.":
          {},
        "Frame 13842831183": {},
        "Frame 39042831180": {},
        "Frame 51842831179": {},
        "Your Promises": {},
        "Frame 42942831187": {},
        "Please always be friendly and welcoming to everyone on every run - some people will be at the very beginning of their running journey and need encouragement! Do not rely on our service or safety in numbers to protect you while running - if you wouldn\u2019t independently run somewhere yourself, don\u2019t do it because our app recommended it or because someone else suggested the route Never run in a group of less than three - we will never plan such small events, but no-shows are always possible. If less than three people turn up we recommend not continuing with the event Please try to arrive promptly, we recommend that runs begin at 5 minutes past the allocated time to allow time to say hello and agree a route Please let us know if you can\u2019t make an event for any reason (e.g. weather, emergency, illness etc.) Please run as you would normally on your own, being attentive to traffic and other hazards you may encounter Please run at the event\u2019s suggested pace or to the slowest runner\u2019s preference! If you see someone breathing heavily and struggling to talk, be kind! Slow down! Please let us know if you have a bad experience for any reason, we would like the opportunity to improve!":
          {},
        "Frame 13842831189": {},
        "Frame 39042831186": {},
        "Frame 519": {},
        "Frame 6342831178": {},
        Guidelines42831175: {},
        "Terms and Conditions of Service": {},
        "Frame 43242831192": {},
        'These terms and conditions outline the rules and regulations for the use of Rundezvous Ltd\'s Website, located at www.rundezvous.co.uk and www.rundezvous.io. By accessing this website we assume you accept these terms and conditions. Do not continue to use Rundezvous if you do not agree to take all of the terms and conditions stated on this page. The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company\'s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client\'s needs in respect of provision of the Company\'s stated services, in accordance with and subject to, prevailing law of gb. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.':
          {},
        "Frame 13842831197": {},
        "Acceptable Use": {},
        "Rundezvous is a service which automatically generates social running events for its users according to their location, schedule and various other preferences. It is intended only for this purpose and should not be used for any other. Rendezvous contains functionality for the following: Authentication of users (rundezvous.io) Viewing a list of running events that have been generated (rundezvous.io) Submitting and updating user details and preferences (rundezvous.io) Updating weekly schedule (rundezvous.io) View subscription details (link to Stripe) (rundezvous.io) Front-end website for general information (rundezvous.co.uk) Emailing for scheduling purposes (from @rundezvous.co.uk)":
          {},
        "Frame 53842831199": {},
        Restrictions: {},
        "Prohibited use includes for: illegal or abusive activities including but not limited to activities which are harassing, hateful, threatening, discriminatory,encourage violence or which are sexually obscene or exploitative. Inauthentic or rights-infringing including but not limited to fraudulent activity, misuse or appropriation of others data or misuse or appropriation of intellectual property\u00A0 Malicious or harmful activity to both other users, and the Rundezvous systems themselves. Users should not seek to access information to which they are not authorised. Users should not attempt to collect or harvest information about events and users on the service. Users should not use the services in a manner for which they are not intended. Users should not submit personal information other than that required specifically to provide the service. Users should only use the system if they are authorised to do so. Enforcement Rundezvous retains the right to remove content and suspend/delete accounts due to violations under this policy.":
          {},
        "Frame 53142831202": {},
        Cookies: {},
        "We employ the use of cookies. By accessing Rundezvous, you agreed to use cookies in agreement with the Rundezvous Ltd's Privacy Policy. Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.":
          {},
        "Frame 53242831205": {},
        License: {},
        "Unless otherwise stated, Rundezvous Ltd and/or its licensors own the intellectual property rights for all material on Rundezvous. All intellectual property rights are reserved. You may access this from Rundezvous for your own personal use subjected to restrictions set in these terms and conditions. You must not: Republish material from Rundezvous Sell, rent or sub-license material from Rundezvous Reproduce, duplicate or copy material from Rundezvous Redistribute content from Rundezvous This Agreement shall begin on the date hereof.\u00A0 Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Rundezvous Ltd does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Rundezvous Ltd,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Rundezvous Ltd shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website. Rundezvous Ltd reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions. You warrant and represent that: You are entitled to post the Comments on our website and have all necessary licenses and consents to do so; The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party; The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity. You hereby grant Rundezvous Ltd a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.":
          {},
        "Frame 53342831208": {},
        "Hyperlinking to our Content": {},
        "The following organizations may link to our Website without prior written approval: Government agencies; Search engines; News organizations; Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site. These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site. We may consider and approve other link requests from the following types of organizations: commonly-known consumer and/or business information sources; dot.com community sites; associations or other groups representing charities; online directory distributors; internet portals; accounting, law and consulting firms; and educational institutions and trade associations. We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Rundezvous Ltd; and (d) the link is in the context of general resource information. These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site. If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Rundezvous Ltd. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response. Approved organizations may hyperlink to our Website as follows: By use of our corporate name; or By use of the uniform resource locator being linked to; or By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site. No use of Rundezvous Ltd's logo or other artwork will be allowed for linking absent a trademark license agreement.":
          {},
        "Frame 53442831211": {},
        iFrames: {},
        "Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.":
          {},
        "Frame 53542831214": {},
        "Acknowledgements and warranty limitations": {},
        "The Customer acknowledges that complex software is never wholly free from defects, errors and bugs; and subject to the other provisions of this Agreement, the Provider gives no warranty or representation that the Hosted Services will be wholly free from defects, errors and bugs. The Customer acknowledges that complex software is never entirely free from security vulnerabilities; and subject to the other provisions of this Agreement, the Provider gives no warranty or representation that the Hosted Services will be entirely secure. The Customer acknowledges that the Hosted Services are designed to be compatible only with that software and those systems [specified as compatible in the Hosted Services Specification]; and the Provider does not warrant or represent that the Hosted Services will be compatible with any other software or systems. The Customer acknowledges that the Provider will not provide any [legal, financial, accountancy or taxation advice] under this Agreement or in relation to the Hosted Services; and, except to the extent expressly provided otherwise in this Agreement, the Provider does not warrant or represent that the Hosted Services or the use of the Hosted Services by the Customer will not give rise to any legal liability on the part of the Customer or any other person.":
          {},
        "Frame 53642831217": {},
        "Limitations and exclusions of liability": {},
        "Nothing in this Agreement will limit or exclude any liability for death or personal injury resulting from negligence; limit or exclude any liability for fraud or fraudulent misrepresentation; limit any liabilities in any way that is not permitted under applicable law; or exclude any liabilities that may not be excluded under applicable law. The limitations and exclusions of liability set out in this clause and elsewhere in this Agreement; and govern all liabilities arising under this Agreement or relating to the subject matter of this Agreement, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in this Agreement. Neither party shall be liable to the other party in respect of any losses arising out of a Force Majeure Event. Neither party shall be liable to the other party in respect of any loss of profits or anticipated savings. Neither party shall be liable to the other party in respect of any loss of revenue or income. Neither party shall be liable to the other party in respect of any loss of use or production. Neither party shall be liable to the other party in respect of any loss of business, contracts or opportunities. Neither party shall be liable to the other party in respect of any loss or corruption of any data, database or software. Neither party shall be liable to the other party in respect of any special, indirect or consequential loss or damage. The liability of each party to the other party under this Agreement in respect of any event or series of related events shall not exceed the greater of: (a) \u00A336; and (b) the total amount paid and payable by the Customer to the Provider under this Agreement in the 12-month period preceding the commencement of the event or events. The aggregate liability of the Provider to the Customer under this Agreement shall not exceed the greater of: (a) \u00A336; and (b) the total amount paid and payable by the Customer to the Provider under this Agreement.":
          {},
        "Frame 53742831220": {},
        "Content Liability": {},
        "We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.":
          {},
        "Frame 52642831223": {},
        "Payment Terms": {},
        "The only payment method supported currently is Stripe. By using this service you authorise Rundezvous to receive and update data with Stripe about your subscription. You may at any time cancel your subscription through Stripe. If you cancel you will lose access to Rundezvous at the end of your current billing period.":
          {},
        "Frame 52742831226": {},
        Fees: {},
        "Subscription fees for Rundezvous are paid on a monthly basis via Stripe. All fees are paid in advance. By using the service you agree to pay all subscription fees. Rundezvous may increase or change the charging structure at any time with reasonable advance notice to users.":
          {},
        "Frame 52842831229": {},
        "Auto-Renewal": {},
        "Auto-Renewal is a key feature of Rundezvous removing admin from users. When a subscription is entered into with Stripe, the collection of fees will be done automatically using the payment method provided until the subscription is cancelled.":
          {},
        "Frame 52942831232": {},
        "Applicable Laws": {},
        "All UK laws shall be primarily applicable to the terms of this contract unless local laws take precedence.":
          {},
        "Frame 53042831235": {},
        "Intellectual Property": {},
        "You acknowledge that Rundezvous contains proprietary information\u00A0 that is protected by applicable Intellectual Property laws. You agree not to modify, rent, lease, loan, sell, distribute or create derivative works based on the services and software available on Rundezvous websites. You are granted the right to access and make use of the Rundezvous service on condition that you do not attempt to copy, modify, reverse engineer or create a derivative work from those services.":
          {},
        "Frame 52142831238": {},
        "Reservation of Rights": {},
        "We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and its linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.":
          {},
        "Frame 522": {},
        "Removal of links from our website": {},
        "If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly. We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.":
          {},
        "Frame 523": {},
        Credit: {},
        "This document was created with sections from a template from Docular (SaaS agreement).":
          {},
        "Frame 524": {},
        "Contact information": {},
        "support@rundezvous.io": {},
        "Frame 525": {},
        "Frame 39042831196": {},
        "Frame 51842831195": {},
        "Frame 6342831194": {},
        Terms42831191: {},
        "Privacy Policy": {},
        "Frame 43243101131": {},
        "At Rundezvous, accessible from www.rundezvous.co.uk and www.rundezvous.io,\u00A0 one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Rundezvous and how we use it. If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us. This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Rundezvous. This policy is not applicable to any information collected offline or via channels other than this website.":
          {},
        "Frame 13843101136": {},
        Consent: {},
        "By using our website, you hereby consent to our Privacy Policy and agree to its terms. Information we collect The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information. If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide. When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number. In order to make use of the service we may require other information about you, including but not limited to your location, schedules and event preferences. When using third-party services (such as Stripe for subscriptions and billing), their Privacy policy will apply and we will not copy or retain your personal information you may submit to them.":
          {},
        "Frame 53843101138": {},
        "How we use your information": {},
        "We use the information we collect in various ways, including to: Provide, operate, and maintain our website Improve, personalize, and expand our website Understand and analyse how you use our website Develop new products, services, features, and functionality Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes Send you emails Find and prevent fraud":
          {},
        "Frame 53143101141": {},
        "Information Sharing": {},
        "We may share non-Personal Data with third parties. We may share your Personal Data with subcontractors or affiliates, subject to confidentiality obligations to use it only for the purposes for which we disclose it to them and pursuant to our instructions.\u00A0 We may also share Personal Data with interested parties in the event that Rundezvous Ltd anticipates a change in control or the acquisition of all or part of our business or assets or with interested parties in connection with the licensing of our technology. If Rundezvous Ltd is sold or makes a sale or transfer, we may, in our sole discretion, transfer, sell or assign your Personal Data to a third party as part of or in connection with that transaction.\u00A0 Upon such transfer, the Privacy Policy of the acquiring entity may govern the further use of your Personal Data. In all other situations your data will still remain protected in accordance with this Privacy Policy (as amended from time to time). We may share your Personal Data at any time if required for legal reasons or in order to enforce our terms or this Privacy Policy.\u00A0":
          {},
        "Frame 53243101144": {},
        "International Transfer of Data": {},
        "Your information may be stored and processed in the UK or other countries or jurisdictions outside the UK where Rundezvous Ltd has facilities. By using Rundezvous Ltd, you are permitting and consenting to the transfer of information, including Personal Data, outside of the UK.":
          {},
        "Frame 53343101147": {},
        "How We Protect Information": {},
        "Rundezvous has various security measures and controls to protect the data we collect. We employ reasonable protections for your data. We cannot guarantee absolute security of your account or information. In addition, you can take steps to protect your account and information such as creating a unique password for Rundezvous that is not easily guessed and that you don't use anywhere else, not sharing your password with others, and promptly reporting suspicious activity or unauthorized account access.":
          {},
        "Frame 53443101150": {},
        "Changes to This Privacy Policy": {},
        "We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page. Our Privacy Policy was created with the help of the Privacy Policy Generator.":
          {},
        "Frame 53543101153": {},
        "Children's Information": {},
        "Rundezvous does not knowingly collect any Personal Identifiable Information from children under the age of 18. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.":
          {},
        "Frame 53643101156": {},
        "Age Limit for Our Users": {},
        "You must not use Rundezvous Ltd unless you are aged 18 or older. If you are under 18 and you access Rundezvous Ltd by lying about your age, you must immediately stop using Rundezvous Ltd. This website is not intended for children and we do not knowingly collect data relating to children.":
          {},
        "Frame 53743101159": {},
        "GDPR Data Protection Rights": {},
        "We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following: The right to access \u2013 You have the right to request copies of your personal data. We may charge you a small fee for this service. The right to rectification \u2013 You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete. The right to erasure \u2013 You have the right to request that we erase your personal data, under certain conditions. The right to restrict processing \u2013 You have the right to request that we restrict the processing of your personal data, under certain conditions. The right to object to processing \u2013 You have the right to object to our processing of your personal data, under certain conditions. The right to data portability \u2013 You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions. If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.":
          {},
        "Frame 52643101162": {},
        "Third Party Privacy Policies": {},
        "This Site may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you.\u00A0 Rundezvous's Privacy Policy does not apply to other advertisers or websites and Rundezvous is not responsible for their privacy statements.. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.":
          {},
        "Frame 52743101165": {},
        "Advertising Partners Privacy Policies": {},
        "You may consult this list to find the Privacy Policy for each of the advertising partners of Rundezvous. Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Rundezvous, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit. Note that Rundezvous has no access to or control over these cookies that are used by third-party advertisers.":
          {},
        "Frame 52843101168": {},
        "Our Advertising Partners": {},
        "Some of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below. Google: policies.google.com/technologies/ads":
          {},
        "Frame 52943101171": {},
        "Cookies and Web Beacons": {},
        "Like any other website, Rundezvous uses \"cookies\". These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.":
          {},
        "Frame 53043101174": {},
        "Log Files": {},
        "Rundezvous follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.":
          {},
        "Frame 52143101177": {},
        "Frame 39043101135": {},
        "Frame 51843101134": {},
        "Frame 6343101133": {},
        Privacy2: {},
        Rundezvous: {},
        "Frame 434": {},
        "Frame 313": {},
        Navigation: {},
        Home: {},
        Terms42831315: {},
        Terms42831316: {},
        Support: {},
        "Frame 403": {},
        "Frame 405": {},
        "long+logo+overlapped+(1) 142831319": {},
        LogoWithText: {},
        "\u00A9 2024 Rundezvous Ltd. All rights reserved.": {},
        "Frame 433": {},
        Footer: {},
        MobileTerms: {},
      },
      variantValues: {},
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  const longPluslogoPlusoverlappedPlusOpenParenthesisOneCloseParenthesisOneFourTwoEightThreeOneOneSixOneOnClick =
    useNavigateAction({ type: "url", url: homeurl });
  const buttonOnClick = useNavigateAction({ type: "url", url: loginurl });
  const termsFourTwoEightThreeOneOneSevenOneOnClick = useNavigateAction({
    anchor: termsAnchor,
    type: "anchor",
  });
  const privacyOnClick = useNavigateAction({
    anchor: privacyAnchor,
    type: "anchor",
  });
  const homeOnClick = useNavigateAction({ type: "url", url: homeurl });
  const termsFourTwoEightThreeOneThreeOneFiveOnClick = useNavigateAction({
    type: "url",
    url: termsurl,
  });
  const termsFourTwoEightThreeOneThreeOneSixOnClick = useNavigateAction({
    type: "url",
    url: loginurl,
  });
  const supportOnClick = useNavigateAction({ type: "url", url: supporturl });
  return (
    <Flex
      gap="0"
      direction="column"
      width="350px"
      height="unset"
      justifyContent="center"
      alignItems="center"
      position="relative"
      padding="0px 0px 0px 0px"
      display="flex"
      {...getOverrideProps(overrides, "MobileTerms")}
      {...rest}
    >
      <Flex
        gap="40px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="center"
        alignItems="center"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        boxShadow="0px 2px 6px rgba(0.05098039284348488, 0.10196078568696976, 0.14901961386203766, 0.15000000596046448)"
        padding="10px 20px 10px 20px"
        backgroundColor="rgba(125,26,183,1)"
        display="flex"
        {...getOverrideProps(overrides, "Header")}
      >
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 517")}
        >
          <Image
            width="186.03px"
            height="40px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            objectFit="cover"
            src={logosrc}
            onClick={() => {
              longPluslogoPlusoverlappedPlusOpenParenthesisOneCloseParenthesisOneFourTwoEightThreeOneOneSixOneOnClick();
            }}
            {...getOverrideProps(
              overrides,
              "long+logo+overlapped+(1) 142831161"
            )}
          ></Image>
        </Flex>
        <Flex
          gap="32px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-end"
          alignItems="center"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 321")}
        >
          <Button
            width="unset"
            height="unset"
            shrink="0"
            backgroundColor="rgba(84,18,125,1)"
            size="large"
            isDisabled={false}
            variation="primary"
            children="Sign in"
            onClick={() => {
              buttonOnClick();
            }}
            {...getOverrideProps(overrides, "Button")}
          ></Button>
        </Flex>
      </Flex>
      <Flex
        gap="0"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="center"
        alignItems="center"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        backgroundColor="rgba(255,255,255,1)"
        display="flex"
        {...getOverrideProps(overrides, "What")}
      >
        <Flex
          gap="10px"
          direction="column"
          width="unset"
          height="400px"
          justifyContent="center"
          alignItems="center"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="20px 10px 20px 10px"
          backgroundColor="rgba(255,255,255,1)"
          display="flex"
          {...getOverrideProps(overrides, "Left")}
        >
          <Flex
            gap="24px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            display="flex"
            {...getOverrideProps(overrides, "HeroMessage")}
          >
            <Flex
              gap="0"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              display="flex"
              {...getOverrideProps(overrides, "Message42831167")}
            >
              <Text
                //fontFamily="Inter"
                fontSize="20px"
                fontWeight="600"
                color="rgba(13,26,38,1)"
                lineHeight="30px"
                textAlign="center"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Rundezvous Guidelines and Terms of Service"
                {...getOverrideProps(overrides, "Heading")}
              ></Text>
            </Flex>
          </Flex>
          <Flex
            gap="16px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            display="flex"
            {...getOverrideProps(overrides, "Message42831170")}
          >
            <Text
              //fontFamily="Inter"
              fontSize="14px"
              fontWeight="600"
              color="rgba(0,0,0,1)"
              fontStyle="italic"
              lineHeight="50px"
              textAlign="center"
              display="block"
              direction="column"
              justifyContent="unset"
              textDecoration="underline"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Terms of Service"
              onClick={() => {
                termsFourTwoEightThreeOneOneSevenOneOnClick();
              }}
              {...getOverrideProps(overrides, "Terms42831171")}
            ></Text>
            <Text
              //fontFamily="Inter"
              fontSize="14px"
              fontWeight="600"
              color="rgba(13,26,38,1)"
              fontStyle="italic"
              lineHeight="50px"
              textAlign="center"
              display="block"
              direction="column"
              justifyContent="unset"
              textDecoration="underline"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Privacy Policy"
              onClick={() => {
                privacyOnClick();
              }}
              {...getOverrideProps(overrides, "Privacy")}
            ></Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        gap="24px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        overflow="hidden"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="20px 0px 20px 0px"
        backgroundColor="rgba(250,250,250,1)"
        display="flex"
        {...getOverrideProps(overrides, "Guidelines42831175")}
      >
        <Flex
          gap="12px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 43242831176")}
        >
          <Text
            //fontFamily="Inter"
            fontSize="32px"
            fontWeight="600"
            color="rgba(13,26,38,1)"
            lineHeight="32px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Guidelines"
            {...getOverrideProps(overrides, "Guidelines42831177")}
          ></Text>
        </Flex>
        <Flex
          gap="0"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 6342831178")}
        >
          <Flex
            gap="10px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            borderRadius="20px"
            padding="0px 24px 0px 24px"
            display="flex"
            {...getOverrideProps(overrides, "Frame 51842831179")}
          >
            <Flex
              gap="24px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              boxShadow="0px 2px 4px rgba(0.05098039284348488, 0.10196078568696976, 0.14901961386203766, 0.05000000074505806)"
              borderRadius="8px"
              padding="32px 32px 32px 32px"
              backgroundColor="rgba(255,255,255,1)"
              display="flex"
              {...getOverrideProps(overrides, "Frame 39042831180")}
            >
              <Flex
                gap="8px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 42942831181")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="32px"
                  fontWeight="600"
                  color="rgba(13,26,38,1)"
                  lineHeight="25px"
                  textAlign="center"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Our Promises"
                  {...getOverrideProps(overrides, "Our Promises")}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 13842831183")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="&#xA;We will always do our best to make our service as safe and secure as possible while also making it work for you&#xA;&#xA;We will always minimise the amount of data about you we hold to reduce the risk to you&#xA;&#xA;We will always listen to your feedback and continually improve our service&#xA;&#xA;We will always refund your subscription if the service has not delivered enough value*&#xA;&#xA;If you tell us your gender we will always make sure you are not the only one of your gender at an event&#xA;&#xA;We will always do our best to match you with events that most closely match your preferences&#xA;&#xA;&#xA;&#xA;&#xA;*if you are not matched with at least 4 runs per month within 2km of where you live."
                  {...getOverrideProps(
                    overrides,
                    "We will always do our best to make our service as safe and secure as possible while also making it work for you We will always minimise the amount of data about you we hold to reduce the risk to you We will always listen to your feedback and continually improve our service We will always refund your subscription if the service has not delivered enough value* If you tell us your gender we will always make sure you are not the only one of your gender at an event We will always do our best to match you with events that most closely match your preferences *if you are not matched with at least 4 runs per month within 2km of where you live."
                  )}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            gap="10px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="center"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 24px 0px 24px"
            display="flex"
            {...getOverrideProps(overrides, "Frame 519")}
          >
            <Flex
              gap="24px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="center"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              boxShadow="0px 2px 4px rgba(0.05098039284348488, 0.10196078568696976, 0.14901961386203766, 0.05000000074505806)"
              borderRadius="8px"
              padding="32px 32px 32px 32px"
              backgroundColor="rgba(255,255,255,1)"
              display="flex"
              {...getOverrideProps(overrides, "Frame 39042831186")}
            >
              <Flex
                gap="8px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="center"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 42942831187")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="32px"
                  fontWeight="600"
                  color="rgba(13,26,38,1)"
                  lineHeight="25px"
                  textAlign="center"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Your Promises"
                  {...getOverrideProps(overrides, "Your Promises")}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 13842831189")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="&#xA;Please always be friendly and welcoming to everyone on every run - some people will be at the very beginning of their running journey and need encouragement!&#xA;&#xA;Do not rely on our service or safety in numbers to protect you while running - if you wouldn’t independently run somewhere yourself, don’t do it because our app recommended it or because someone else suggested the route&#xA;&#xA;Never run in a group of less than three - we will never plan such small events, but no-shows are always possible. If less than three people turn up we recommend not continuing with the event&#xA;&#xA;Please try to arrive promptly, we recommend that runs begin at 5 minutes past the allocated time to allow time to say hello and agree a route&#xA;&#xA;Please let us know if you can’t make an event for any reason (e.g. weather, emergency, illness etc.)&#xA;&#xA;Please run as you would normally on your own, being attentive to traffic and other hazards you may encounter&#xA;&#xA;Please run at the event’s suggested pace or to the slowest runner’s preference! If you see someone breathing heavily and struggling to talk, be kind! Slow down!&#xA;&#xA;Please let us know if you have a bad experience for any reason, we would like the opportunity to improve!"
                  {...getOverrideProps(
                    overrides,
                    "Please always be friendly and welcoming to everyone on every run - some people will be at the very beginning of their running journey and need encouragement! Do not rely on our service or safety in numbers to protect you while running - if you wouldn\u2019t independently run somewhere yourself, don\u2019t do it because our app recommended it or because someone else suggested the route Never run in a group of less than three - we will never plan such small events, but no-shows are always possible. If less than three people turn up we recommend not continuing with the event Please try to arrive promptly, we recommend that runs begin at 5 minutes past the allocated time to allow time to say hello and agree a route Please let us know if you can\u2019t make an event for any reason (e.g. weather, emergency, illness etc.) Please run as you would normally on your own, being attentive to traffic and other hazards you may encounter Please run at the event\u2019s suggested pace or to the slowest runner\u2019s preference! If you see someone breathing heavily and struggling to talk, be kind! Slow down! Please let us know if you have a bad experience for any reason, we would like the opportunity to improve!"
                  )}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        gap="24px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        overflow="hidden"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="20px 10px 20px 10px"
        backgroundColor="rgba(250,250,250,1)"
        display="flex"
        {...getOverrideProps(overrides, "Terms42831191")}
      >
        <Flex
          gap="12px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 43242831192")}
        >
          <Text
            //fontFamily="Inter"
            fontSize="32px"
            fontWeight="600"
            color="rgba(13,26,38,1)"
            lineHeight="32px"
            textAlign="center"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            id={termsAnchor}
            children="Terms and Conditions of Service"
            {...getOverrideProps(overrides, "Terms and Conditions of Service")}
          ></Text>
        </Flex>
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,0)"
          display="flex"
          {...getOverrideProps(overrides, "Frame 6342831194")}
        >
          <Flex
            gap="10px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            grow="1"
            shrink="1"
            basis="0"
            position="relative"
            padding="0px 10px 0px 10px"
            display="flex"
            {...getOverrideProps(overrides, "Frame 51842831195")}
          >
            <Flex
              gap="24px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              boxShadow="0px 2px 4px rgba(0.05098039284348488, 0.10196078568696976, 0.14901961386203766, 0.05000000074505806)"
              borderRadius="8px"
              padding="32px 10px 32px 10px"
              backgroundColor="rgba(255,255,255,1)"
              display="flex"
              {...getOverrideProps(overrides, "Frame 39042831196")}
            >
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 13842831197")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children='These terms and conditions outline the rules and regulations for the use of Rundezvous Ltd&apos;s Website, located at www.rundezvous.co.uk and www.rundezvous.io.&#xA;&#xA;By accessing this website we assume you accept these terms and conditions. Do not continue to use Rundezvous if you do not agree to take all of the terms and conditions stated on this page.&#xA;&#xA;The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company&apos;s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client&apos;s needs in respect of provision of the Company&apos;s stated services, in accordance with and subject to, prevailing law of gb. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.'
                  {...getOverrideProps(
                    overrides,
                    'These terms and conditions outline the rules and regulations for the use of Rundezvous Ltd\'s Website, located at www.rundezvous.co.uk and www.rundezvous.io. By accessing this website we assume you accept these terms and conditions. Do not continue to use Rundezvous if you do not agree to take all of the terms and conditions stated on this page. The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company\'s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client\'s needs in respect of provision of the Company\'s stated services, in accordance with and subject to, prevailing law of gb. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.'
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53842831199")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Acceptable Use"
                  {...getOverrideProps(overrides, "Acceptable Use")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Rundezvous is a service which automatically generates social running events for its users according to their location, schedule and various other preferences. It is intended only for this purpose and should not be used for any other.&#xA;&#xA;Rendezvous contains functionality for the following:&#xA;&#xA;Authentication of users (rundezvous.io)&#xA;&#xA;Viewing a list of running events that have been generated (rundezvous.io)&#xA;&#xA;Submitting and updating user details and preferences (rundezvous.io)&#xA;&#xA;Updating weekly schedule (rundezvous.io)&#xA;&#xA;View subscription details (link to Stripe) (rundezvous.io)&#xA;&#xA;Front-end website for general information (rundezvous.co.uk)&#xA;&#xA;Emailing for scheduling purposes (from @rundezvous.co.uk)"
                  {...getOverrideProps(
                    overrides,
                    "Rundezvous is a service which automatically generates social running events for its users according to their location, schedule and various other preferences. It is intended only for this purpose and should not be used for any other. Rendezvous contains functionality for the following: Authentication of users (rundezvous.io) Viewing a list of running events that have been generated (rundezvous.io) Submitting and updating user details and preferences (rundezvous.io) Updating weekly schedule (rundezvous.io) View subscription details (link to Stripe) (rundezvous.io) Front-end website for general information (rundezvous.co.uk) Emailing for scheduling purposes (from @rundezvous.co.uk)"
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53142831202")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Restrictions"
                  {...getOverrideProps(overrides, "Restrictions")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Prohibited use includes for:&#xA;&#xA;illegal or abusive activities including but not limited to activities which are harassing, hateful, threatening, discriminatory,encourage violence or which are sexually obscene or exploitative.&#xA;&#xA;Inauthentic or rights-infringing including but not limited to fraudulent activity, misuse or appropriation of others data or misuse or appropriation of intellectual property &#xA;&#xA;Malicious or harmful activity to both other users, and the Rundezvous systems themselves.&#xA;&#xA;Users should not seek to access information to which they are not authorised. Users should not attempt to collect or harvest information about events and users on the service. Users should not use the services in a manner for which they are not intended. Users should not submit personal information other than that required specifically to provide the service. Users should only use the system if they are authorised to do so.&#xA;Enforcement&#xA;&#xA;Rundezvous retains the right to remove content and suspend/delete accounts due to violations under this policy."
                  {...getOverrideProps(
                    overrides,
                    "Prohibited use includes for: illegal or abusive activities including but not limited to activities which are harassing, hateful, threatening, discriminatory,encourage violence or which are sexually obscene or exploitative. Inauthentic or rights-infringing including but not limited to fraudulent activity, misuse or appropriation of others data or misuse or appropriation of intellectual property\u00A0 Malicious or harmful activity to both other users, and the Rundezvous systems themselves. Users should not seek to access information to which they are not authorised. Users should not attempt to collect or harvest information about events and users on the service. Users should not use the services in a manner for which they are not intended. Users should not submit personal information other than that required specifically to provide the service. Users should only use the system if they are authorised to do so. Enforcement Rundezvous retains the right to remove content and suspend/delete accounts due to violations under this policy."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53242831205")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Cookies"
                  {...getOverrideProps(overrides, "Cookies")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We employ the use of cookies. By accessing Rundezvous, you agreed to use cookies in agreement with the Rundezvous Ltd's Privacy Policy.&#xA;Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies."
                  {...getOverrideProps(
                    overrides,
                    "We employ the use of cookies. By accessing Rundezvous, you agreed to use cookies in agreement with the Rundezvous Ltd's Privacy Policy. Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53342831208")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="License"
                  {...getOverrideProps(overrides, "License")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Unless otherwise stated, Rundezvous Ltd and/or its licensors own the intellectual property rights for all material on Rundezvous. All intellectual property rights are reserved. You may access this from Rundezvous for your own personal use subjected to restrictions set in these terms and conditions.&#xA;&#xA;You must not:&#xA;&#xA;Republish material from Rundezvous&#xA;&#xA;Sell, rent or sub-license material from Rundezvous&#xA;&#xA;Reproduce, duplicate or copy material from Rundezvous&#xA;&#xA;Redistribute content from Rundezvous&#xA;&#xA;This Agreement shall begin on the date hereof. &#xA;&#xA;Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Rundezvous Ltd does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Rundezvous Ltd,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Rundezvous Ltd shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.&#xA;&#xA;Rundezvous Ltd reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.&#xA;&#xA;You warrant and represent that:&#xA;&#xA;You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;&#xA;&#xA;The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;&#xA;&#xA;The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy&#xA;&#xA;The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.&#xA;&#xA;You hereby grant Rundezvous Ltd a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media."
                  {...getOverrideProps(
                    overrides,
                    "Unless otherwise stated, Rundezvous Ltd and/or its licensors own the intellectual property rights for all material on Rundezvous. All intellectual property rights are reserved. You may access this from Rundezvous for your own personal use subjected to restrictions set in these terms and conditions. You must not: Republish material from Rundezvous Sell, rent or sub-license material from Rundezvous Reproduce, duplicate or copy material from Rundezvous Redistribute content from Rundezvous This Agreement shall begin on the date hereof.\u00A0 Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Rundezvous Ltd does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Rundezvous Ltd,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Rundezvous Ltd shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website. Rundezvous Ltd reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions. You warrant and represent that: You are entitled to post the Comments on our website and have all necessary licenses and consents to do so; The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party; The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity. You hereby grant Rundezvous Ltd a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53442831211")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Hyperlinking to our Content"
                  {...getOverrideProps(
                    overrides,
                    "Hyperlinking to our Content"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="The following organizations may link to our Website without prior written approval:&#xA;Government agencies;&#xA;&#xA;Search engines;&#xA;&#xA;News organizations;&#xA;&#xA;Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and&#xA;&#xA;System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.&#xA;&#xA;These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site.&#xA;&#xA;We may consider and approve other link requests from the following types of organizations:&#xA;&#xA;commonly-known consumer and/or business information sources;&#xA;&#xA;dot.com community sites;&#xA;&#xA;associations or other groups representing charities;&#xA;&#xA;online directory distributors;&#xA;&#xA;internet portals;&#xA;&#xA;accounting, law and consulting firms; and&#xA;&#xA;educational institutions and trade associations.&#xA;&#xA;We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Rundezvous Ltd; and (d) the link is in the context of general resource information.&#xA;&#xA;These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site.&#xA;&#xA;If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Rundezvous Ltd. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.&#xA;&#xA;Approved organizations may hyperlink to our Website as follows:&#xA;&#xA;By use of our corporate name; or&#xA;&#xA;By use of the uniform resource locator being linked to; or&#xA;&#xA;By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site.&#xA;&#xA;No use of Rundezvous Ltd's logo or other artwork will be allowed for linking absent a trademark license agreement."
                  {...getOverrideProps(
                    overrides,
                    "The following organizations may link to our Website without prior written approval: Government agencies; Search engines; News organizations; Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site. These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site. We may consider and approve other link requests from the following types of organizations: commonly-known consumer and/or business information sources; dot.com community sites; associations or other groups representing charities; online directory distributors; internet portals; accounting, law and consulting firms; and educational institutions and trade associations. We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Rundezvous Ltd; and (d) the link is in the context of general resource information. These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site. If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Rundezvous Ltd. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response. Approved organizations may hyperlink to our Website as follows: By use of our corporate name; or By use of the uniform resource locator being linked to; or By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site. No use of Rundezvous Ltd's logo or other artwork will be allowed for linking absent a trademark license agreement."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53542831214")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="iFrames"
                  {...getOverrideProps(overrides, "iFrames")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website."
                  {...getOverrideProps(
                    overrides,
                    "Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53642831217")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Acknowledgements and warranty limitations"
                  {...getOverrideProps(
                    overrides,
                    "Acknowledgements and warranty limitations"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="The Customer acknowledges that complex software is never wholly free from defects, errors and bugs; and subject to the other provisions of this Agreement, the Provider gives no warranty or representation that the Hosted Services will be wholly free from defects, errors and bugs.&#xA;&#xA;The Customer acknowledges that complex software is never entirely free from security vulnerabilities; and subject to the other provisions of this Agreement, the Provider gives no warranty or representation that the Hosted Services will be entirely secure.&#xA;&#xA;The Customer acknowledges that the Hosted Services are designed to be compatible only with that software and those systems [specified as compatible in the Hosted Services Specification]; and the Provider does not warrant or represent that the Hosted Services will be compatible with any other software or systems.&#xA;&#xA;The Customer acknowledges that the Provider will not provide any [legal, financial, accountancy or taxation advice] under this Agreement or in relation to the Hosted Services; and, except to the extent expressly provided otherwise in this Agreement, the Provider does not warrant or represent that the Hosted Services or the use of the Hosted Services by the Customer will not give rise to any legal liability on the part of the Customer or any other person."
                  {...getOverrideProps(
                    overrides,
                    "The Customer acknowledges that complex software is never wholly free from defects, errors and bugs; and subject to the other provisions of this Agreement, the Provider gives no warranty or representation that the Hosted Services will be wholly free from defects, errors and bugs. The Customer acknowledges that complex software is never entirely free from security vulnerabilities; and subject to the other provisions of this Agreement, the Provider gives no warranty or representation that the Hosted Services will be entirely secure. The Customer acknowledges that the Hosted Services are designed to be compatible only with that software and those systems [specified as compatible in the Hosted Services Specification]; and the Provider does not warrant or represent that the Hosted Services will be compatible with any other software or systems. The Customer acknowledges that the Provider will not provide any [legal, financial, accountancy or taxation advice] under this Agreement or in relation to the Hosted Services; and, except to the extent expressly provided otherwise in this Agreement, the Provider does not warrant or represent that the Hosted Services or the use of the Hosted Services by the Customer will not give rise to any legal liability on the part of the Customer or any other person."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53742831220")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Limitations and exclusions of liability"
                  {...getOverrideProps(
                    overrides,
                    "Limitations and exclusions of liability"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Nothing in this Agreement will limit or exclude any liability for death or personal injury resulting from negligence; limit or exclude any liability for fraud or fraudulent misrepresentation; limit any liabilities in any way that is not permitted under applicable law; or exclude any liabilities that may not be excluded under applicable law.&#xA;&#xA;The limitations and exclusions of liability set out in this clause and elsewhere in this Agreement; and govern all liabilities arising under this Agreement or relating to the subject matter of this Agreement, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in this Agreement.&#xA;&#xA;Neither party shall be liable to the other party in respect of any losses arising out of a Force Majeure Event.&#xA;&#xA;Neither party shall be liable to the other party in respect of any loss of profits or anticipated savings.&#xA;&#xA;Neither party shall be liable to the other party in respect of any loss of revenue or income.&#xA;&#xA;Neither party shall be liable to the other party in respect of any loss of use or production.&#xA;&#xA;Neither party shall be liable to the other party in respect of any loss of business, contracts or opportunities.&#xA;&#xA;Neither party shall be liable to the other party in respect of any loss or corruption of any data, database or software.&#xA;&#xA;Neither party shall be liable to the other party in respect of any special, indirect or consequential loss or damage.&#xA;&#xA;The liability of each party to the other party under this Agreement in respect of any event or series of related events shall not exceed the greater of:&#xA;&#xA;(a)&#x9;£36; and&#xA;(b)&#x9;the total amount paid and payable by the Customer to the Provider under this Agreement in the 12-month period preceding the commencement of the event or events.&#xA;The aggregate liability of the Provider to the Customer under this Agreement shall not exceed the greater of:&#xA;(a)&#x9;£36; and&#xA;(b)&#x9;the total amount paid and payable by the Customer to the Provider under this Agreement."
                  {...getOverrideProps(
                    overrides,
                    "Nothing in this Agreement will limit or exclude any liability for death or personal injury resulting from negligence; limit or exclude any liability for fraud or fraudulent misrepresentation; limit any liabilities in any way that is not permitted under applicable law; or exclude any liabilities that may not be excluded under applicable law. The limitations and exclusions of liability set out in this clause and elsewhere in this Agreement; and govern all liabilities arising under this Agreement or relating to the subject matter of this Agreement, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in this Agreement. Neither party shall be liable to the other party in respect of any losses arising out of a Force Majeure Event. Neither party shall be liable to the other party in respect of any loss of profits or anticipated savings. Neither party shall be liable to the other party in respect of any loss of revenue or income. Neither party shall be liable to the other party in respect of any loss of use or production. Neither party shall be liable to the other party in respect of any loss of business, contracts or opportunities. Neither party shall be liable to the other party in respect of any loss or corruption of any data, database or software. Neither party shall be liable to the other party in respect of any special, indirect or consequential loss or damage. The liability of each party to the other party under this Agreement in respect of any event or series of related events shall not exceed the greater of: (a) \u00A336; and (b) the total amount paid and payable by the Customer to the Provider under this Agreement in the 12-month period preceding the commencement of the event or events. The aggregate liability of the Provider to the Customer under this Agreement shall not exceed the greater of: (a) \u00A336; and (b) the total amount paid and payable by the Customer to the Provider under this Agreement."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52642831223")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Content Liability"
                  {...getOverrideProps(overrides, "Content Liability")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights."
                  {...getOverrideProps(
                    overrides,
                    "We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52742831226")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Payment Terms"
                  {...getOverrideProps(overrides, "Payment Terms")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="The only payment method supported currently is Stripe. By using this service you authorise Rundezvous to receive and update data with Stripe about your subscription. &#xA;&#xA;You may at any time cancel your subscription through Stripe. If you cancel you will lose access to Rundezvous at the end of your current billing period."
                  {...getOverrideProps(
                    overrides,
                    "The only payment method supported currently is Stripe. By using this service you authorise Rundezvous to receive and update data with Stripe about your subscription. You may at any time cancel your subscription through Stripe. If you cancel you will lose access to Rundezvous at the end of your current billing period."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52842831229")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Fees"
                  {...getOverrideProps(overrides, "Fees")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Subscription fees for Rundezvous are paid on a monthly basis via Stripe. All fees are paid in advance. By using the service you agree to pay all subscription fees. Rundezvous may increase or change the charging structure at any time with reasonable advance notice to users."
                  {...getOverrideProps(
                    overrides,
                    "Subscription fees for Rundezvous are paid on a monthly basis via Stripe. All fees are paid in advance. By using the service you agree to pay all subscription fees. Rundezvous may increase or change the charging structure at any time with reasonable advance notice to users."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52942831232")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Auto-Renewal"
                  {...getOverrideProps(overrides, "Auto-Renewal")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Auto-Renewal is a key feature of Rundezvous removing admin from users. When a subscription is entered into with Stripe, the collection of fees will be done automatically using the payment method provided until the subscription is cancelled."
                  {...getOverrideProps(
                    overrides,
                    "Auto-Renewal is a key feature of Rundezvous removing admin from users. When a subscription is entered into with Stripe, the collection of fees will be done automatically using the payment method provided until the subscription is cancelled."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53042831235")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Applicable Laws"
                  {...getOverrideProps(overrides, "Applicable Laws")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="All UK laws shall be primarily applicable to the terms of this contract unless local laws take precedence."
                  {...getOverrideProps(
                    overrides,
                    "All UK laws shall be primarily applicable to the terms of this contract unless local laws take precedence."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52142831238")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Intellectual Property"
                  {...getOverrideProps(overrides, "Intellectual Property")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="You acknowledge that Rundezvous contains proprietary information  that is protected by applicable Intellectual Property laws. You agree not to modify, rent, lease, loan, sell, distribute or create derivative works based on the services and software available on Rundezvous websites.&#xA;&#xA;You are granted the right to access and make use of the Rundezvous service on condition that you do not attempt to copy, modify, reverse engineer or create a derivative work from those services."
                  {...getOverrideProps(
                    overrides,
                    "You acknowledge that Rundezvous contains proprietary information\u00A0 that is protected by applicable Intellectual Property laws. You agree not to modify, rent, lease, loan, sell, distribute or create derivative works based on the services and software available on Rundezvous websites. You are granted the right to access and make use of the Rundezvous service on condition that you do not attempt to copy, modify, reverse engineer or create a derivative work from those services."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 522")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Reservation of Rights"
                  {...getOverrideProps(overrides, "Reservation of Rights")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and its linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions."
                  {...getOverrideProps(
                    overrides,
                    "We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and its linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 523")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Removal of links from our website"
                  {...getOverrideProps(
                    overrides,
                    "Removal of links from our website"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.&#xA;&#xA;We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date."
                  {...getOverrideProps(
                    overrides,
                    "If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly. We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 524")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Credit"
                  {...getOverrideProps(overrides, "Credit")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="This document was created with sections from a template from Docular (SaaS agreement)."
                  {...getOverrideProps(
                    overrides,
                    "This document was created with sections from a template from Docular (SaaS agreement)."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 525")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Contact information"
                  {...getOverrideProps(overrides, "Contact information")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="support@rundezvous.io"
                  {...getOverrideProps(overrides, "support@rundezvous.io")}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        gap="24px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        overflow="hidden"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="20px 10px 20px 10px"
        backgroundColor="rgba(250,250,250,1)"
        display="flex"
        {...getOverrideProps(overrides, "Privacy2")}
      >
        <Flex
          gap="12px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 43243101131")}
        >
          <Text
            //fontFamily="Inter"
            fontSize="32px"
            fontWeight="600"
            color="rgba(13,26,38,1)"
            lineHeight="32px"
            textAlign="center"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            id={privacyAnchor}
            children="Privacy Policy"
            {...getOverrideProps(overrides, "Privacy Policy")}
          ></Text>
        </Flex>
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(255,255,255,0)"
          display="flex"
          {...getOverrideProps(overrides, "Frame 6343101133")}
        >
          <Flex
            gap="10px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            grow="1"
            shrink="1"
            basis="0"
            position="relative"
            padding="0px 10px 0px 10px"
            display="flex"
            {...getOverrideProps(overrides, "Frame 51843101134")}
          >
            <Flex
              gap="24px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              boxShadow="0px 2px 4px rgba(0.05098039284348488, 0.10196078568696976, 0.14901961386203766, 0.05000000074505806)"
              borderRadius="8px"
              padding="32px 10px 32px 10px"
              backgroundColor="rgba(255,255,255,1)"
              display="flex"
              {...getOverrideProps(overrides, "Frame 39043101135")}
            >
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 13843101136")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="At Rundezvous, accessible from www.rundezvous.co.uk and www.rundezvous.io,  one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Rundezvous and how we use it. If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us. This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Rundezvous. This policy is not applicable to any information collected offline or via channels other than this website."
                  {...getOverrideProps(
                    overrides,
                    "At Rundezvous, accessible from www.rundezvous.co.uk and www.rundezvous.io,\u00A0 one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Rundezvous and how we use it. If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us. This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Rundezvous. This policy is not applicable to any information collected offline or via channels other than this website."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53843101138")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Consent"
                  {...getOverrideProps(overrides, "Consent")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="By using our website, you hereby consent to our Privacy Policy and agree to its terms.&#xA;Information we collect The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information. If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide. When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.&#xA;In order to make use of the service we may require other information about you, including but not limited to your location, schedules and event preferences. When using third-party services (such as Stripe for subscriptions and billing), their Privacy policy will apply and we will not copy or retain your personal information you may submit to them.&#xA;&#xA;"
                  {...getOverrideProps(
                    overrides,
                    "By using our website, you hereby consent to our Privacy Policy and agree to its terms. Information we collect The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information. If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide. When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number. In order to make use of the service we may require other information about you, including but not limited to your location, schedules and event preferences. When using third-party services (such as Stripe for subscriptions and billing), their Privacy policy will apply and we will not copy or retain your personal information you may submit to them."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53143101141")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="How we use your information"
                  {...getOverrideProps(
                    overrides,
                    "How we use your information"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We use the information we collect in various ways, including to: Provide, operate, and maintain our website&#xA;Improve, personalize, and expand our website&#xA;Understand and analyse how you use our website&#xA;Develop new products, services, features, and functionality&#xA;Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes&#xA;Send you emails&#xA;Find and prevent fraud"
                  {...getOverrideProps(
                    overrides,
                    "We use the information we collect in various ways, including to: Provide, operate, and maintain our website Improve, personalize, and expand our website Understand and analyse how you use our website Develop new products, services, features, and functionality Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes Send you emails Find and prevent fraud"
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53243101144")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Information Sharing"
                  {...getOverrideProps(overrides, "Information Sharing")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We may share non-Personal Data with third parties. We may share your Personal Data with subcontractors or affiliates, subject to confidentiality obligations to use it only for the purposes for which we disclose it to them and pursuant to our instructions. &#xA;We may also share Personal Data with interested parties in the event that Rundezvous Ltd anticipates a change in control or the acquisition of all or part of our business or assets or with interested parties in connection with the licensing of our technology. If Rundezvous Ltd is sold or makes a sale or transfer, we may, in our sole discretion, transfer, sell or assign your Personal Data to a third party as part of or in connection with that transaction.  Upon such transfer, the Privacy Policy of the acquiring entity may govern the further use of your Personal Data. In all other situations your data will still remain protected in accordance with this Privacy Policy (as amended from time to time). We may share your Personal Data at any time if required for legal reasons or in order to enforce our terms or this Privacy Policy. "
                  {...getOverrideProps(
                    overrides,
                    "We may share non-Personal Data with third parties. We may share your Personal Data with subcontractors or affiliates, subject to confidentiality obligations to use it only for the purposes for which we disclose it to them and pursuant to our instructions.\u00A0 We may also share Personal Data with interested parties in the event that Rundezvous Ltd anticipates a change in control or the acquisition of all or part of our business or assets or with interested parties in connection with the licensing of our technology. If Rundezvous Ltd is sold or makes a sale or transfer, we may, in our sole discretion, transfer, sell or assign your Personal Data to a third party as part of or in connection with that transaction.\u00A0 Upon such transfer, the Privacy Policy of the acquiring entity may govern the further use of your Personal Data. In all other situations your data will still remain protected in accordance with this Privacy Policy (as amended from time to time). We may share your Personal Data at any time if required for legal reasons or in order to enforce our terms or this Privacy Policy.\u00A0"
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53343101147")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="International Transfer of Data"
                  {...getOverrideProps(
                    overrides,
                    "International Transfer of Data"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Your information may be stored and processed in the UK or other countries or jurisdictions outside the UK where Rundezvous Ltd has facilities. By using Rundezvous Ltd, you are permitting and consenting to the transfer of information, including Personal Data, outside of the UK."
                  {...getOverrideProps(
                    overrides,
                    "Your information may be stored and processed in the UK or other countries or jurisdictions outside the UK where Rundezvous Ltd has facilities. By using Rundezvous Ltd, you are permitting and consenting to the transfer of information, including Personal Data, outside of the UK."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53443101150")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="How We Protect Information"
                  {...getOverrideProps(overrides, "How We Protect Information")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Rundezvous has various security measures and controls to protect the data we collect. We employ reasonable protections for your data. We cannot guarantee absolute security of your account or information. In addition, you can take steps to protect your account and information such as creating a unique password for Rundezvous that is not easily guessed and that you don't use anywhere else, not sharing your password with others, and promptly reporting suspicious activity or unauthorized account access."
                  {...getOverrideProps(
                    overrides,
                    "Rundezvous has various security measures and controls to protect the data we collect. We employ reasonable protections for your data. We cannot guarantee absolute security of your account or information. In addition, you can take steps to protect your account and information such as creating a unique password for Rundezvous that is not easily guessed and that you don't use anywhere else, not sharing your password with others, and promptly reporting suspicious activity or unauthorized account access."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53543101153")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Changes to This Privacy Policy"
                  {...getOverrideProps(
                    overrides,
                    "Changes to This Privacy Policy"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page. Our Privacy Policy was created with the help of the Privacy Policy Generator."
                  {...getOverrideProps(
                    overrides,
                    "We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page. Our Privacy Policy was created with the help of the Privacy Policy Generator."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53643101156")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Children's Information"
                  {...getOverrideProps(overrides, "Children's Information")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Rundezvous does not knowingly collect any Personal Identifiable Information from children under the age of 18. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records."
                  {...getOverrideProps(
                    overrides,
                    "Rundezvous does not knowingly collect any Personal Identifiable Information from children under the age of 18. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53743101159")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Age Limit for Our Users"
                  {...getOverrideProps(overrides, "Age Limit for Our Users")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="You must not use Rundezvous Ltd unless you are aged 18 or older. If you are under 18 and you access Rundezvous Ltd by lying about your age, you must immediately stop using Rundezvous Ltd. This website is not intended for children and we do not knowingly collect data relating to children."
                  {...getOverrideProps(
                    overrides,
                    "You must not use Rundezvous Ltd unless you are aged 18 or older. If you are under 18 and you access Rundezvous Ltd by lying about your age, you must immediately stop using Rundezvous Ltd. This website is not intended for children and we do not knowingly collect data relating to children."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52643101162")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="GDPR Data Protection Rights"
                  {...getOverrideProps(
                    overrides,
                    "GDPR Data Protection Rights"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following: The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.&#xA;The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.&#xA;The right to erasure – You have the right to request that we erase your personal data, under certain conditions.&#xA;The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.&#xA;The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.&#xA;The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions. If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us."
                  {...getOverrideProps(
                    overrides,
                    "We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following: The right to access \u2013 You have the right to request copies of your personal data. We may charge you a small fee for this service. The right to rectification \u2013 You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete. The right to erasure \u2013 You have the right to request that we erase your personal data, under certain conditions. The right to restrict processing \u2013 You have the right to request that we restrict the processing of your personal data, under certain conditions. The right to object to processing \u2013 You have the right to object to our processing of your personal data, under certain conditions. The right to data portability \u2013 You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions. If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52743101165")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Third Party Privacy Policies"
                  {...getOverrideProps(
                    overrides,
                    "Third Party Privacy Policies"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="This Site may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you.  Rundezvous's Privacy Policy does not apply to other advertisers or websites and Rundezvous is not responsible for their privacy statements.. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites."
                  {...getOverrideProps(
                    overrides,
                    "This Site may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you.\u00A0 Rundezvous's Privacy Policy does not apply to other advertisers or websites and Rundezvous is not responsible for their privacy statements.. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52843101168")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Advertising Partners Privacy Policies"
                  {...getOverrideProps(
                    overrides,
                    "Advertising Partners Privacy Policies"
                  )}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="You may consult this list to find the Privacy Policy for each of the advertising partners of Rundezvous. Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Rundezvous, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit. Note that Rundezvous has no access to or control over these cookies that are used by third-party advertisers."
                  {...getOverrideProps(
                    overrides,
                    "You may consult this list to find the Privacy Policy for each of the advertising partners of Rundezvous. Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Rundezvous, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit. Note that Rundezvous has no access to or control over these cookies that are used by third-party advertisers."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52943101171")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Our Advertising Partners"
                  {...getOverrideProps(overrides, "Our Advertising Partners")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Some of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below. &#xA;Google: &#xA;policies.google.com/technologies/ads"
                  {...getOverrideProps(
                    overrides,
                    "Some of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below. Google: policies.google.com/technologies/ads"
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 53043101174")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Cookies and Web Beacons"
                  {...getOverrideProps(overrides, "Cookies and Web Beacons")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Like any other website, Rundezvous uses &quot;cookies&quot;. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information."
                  {...getOverrideProps(
                    overrides,
                    "Like any other website, Rundezvous uses \"cookies\". These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information."
                  )}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                overflow="hidden"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                display="flex"
                {...getOverrideProps(overrides, "Frame 52143101177")}
              >
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="700"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Log Files"
                  {...getOverrideProps(overrides, "Log Files")}
                ></Text>
                <Text
                  //fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  letterSpacing="0.01px"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Rundezvous follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information."
                  {...getOverrideProps(
                    overrides,
                    "Rundezvous follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information."
                  )}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        gap="32px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="40px 40px 40px 40px"
        backgroundColor="rgba(223,188,245,1)"
        display="flex"
        {...getOverrideProps(overrides, "Footer")}
      >
        <Flex
          gap="16px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="space-between"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 313")}
        >
          <Flex
            gap="10px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            grow="1"
            shrink="1"
            basis="0"
            position="relative"
            padding="0px 0px 0px 0px"
            display="flex"
            {...getOverrideProps(overrides, "Frame 434")}
          >
            <Text
              //fontFamily="Inter"
              fontSize="20px"
              fontWeight="600"
              color="rgba(48,64,80,1)"
              lineHeight="30px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="471px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Rundezvous"
              {...getOverrideProps(overrides, "Rundezvous")}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="24px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 405")}
        >
          <Flex
            gap="8px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            display="flex"
            {...getOverrideProps(overrides, "Frame 403")}
          >
            <Text
              //fontFamily="Inter"
              fontSize="16px"
              fontWeight="600"
              color="rgba(48,64,80,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.01px"
              width="272px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Navigation"
              {...getOverrideProps(overrides, "Navigation")}
            ></Text>
            <Text
              //fontFamily="Inter"
              fontSize="16px"
              fontWeight="400"
              color="rgba(157,40,226,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.01px"
              width="272px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Home"
              onClick={() => {
                homeOnClick();
              }}
              {...getOverrideProps(overrides, "Home")}
            ></Text>
            <Text
              //fontFamily="Inter"
              fontSize="16px"
              fontWeight="400"
              color="rgba(157,40,226,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.01px"
              width="272px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Terms"
              onClick={() => {
                termsFourTwoEightThreeOneThreeOneFiveOnClick();
              }}
              {...getOverrideProps(overrides, "Terms42831315")}
            ></Text>
            <Text
              //fontFamily="Inter"
              fontSize="16px"
              fontWeight="400"
              color="rgba(157,40,226,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.01px"
              width="272px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Login"
              onClick={() => {
                termsFourTwoEightThreeOneThreeOneSixOnClick();
              }}
              {...getOverrideProps(overrides, "Terms42831316")}
            ></Text>
            <Text
              //fontFamily="Inter"
              fontSize="16px"
              fontWeight="400"
              color="rgba(157,40,226,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.01px"
              width="272px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Support"
              onClick={() => {
                supportOnClick();
              }}
              {...getOverrideProps(overrides, "Support")}
            ></Text>
          </Flex>
        </Flex>
        <Flex
          gap="0"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          display="flex"
          {...getOverrideProps(overrides, "Frame 433")}
        >
          <Flex
            gap="10px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="center"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            display="flex"
            {...getOverrideProps(overrides, "LogoWithText")}
          >
            <Image
              width="197px"
              height="39px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              objectFit="cover"
              src={logosrc}
              {...getOverrideProps(
                overrides,
                "long+logo+overlapped+(1) 142831319"
              )}
            ></Image>
          </Flex>
          <Text
            //fontFamily="Inter"
            fontSize="16px"
            fontWeight="400"
            color="rgba(102,112,133,1)"
            lineHeight="24px"
            textAlign="right"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="© 2024 Rundezvous Ltd. All rights reserved."
            {...getOverrideProps(
              overrides,
              "\u00A9 2024 Rundezvous Ltd. All rights reserved."
            )}
          ></Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
